import type { RegisterPolicy } from '@/lib/auth/register-api';

/** Returns true if the password satisfies all rules in the policy. */
export function passwordMeetsPolicy(
  pw: string,
  policy: RegisterPolicy['passwordPolicy'],
): boolean {
  if (pw.length < policy.minLength) return false;
  if (policy.requireUppercase && !/[A-Z]/.test(pw)) return false;
  if (policy.requireLowercase && !/[a-z]/.test(pw)) return false;
  if (policy.requireDigit && !/[0-9]/.test(pw)) return false;
  if (policy.requireSpecial && !/[^A-Za-z0-9]/.test(pw)) return false;
  return true;
}
